import moment from "jalali-moment";

export const chillingChartStepHelper = (chartChillingData) => {
  const screenWidth = window.innerWidth;

  if (screenWidth < 1023) {
    return 45;
  } else if (chartChillingData?.dailyUtahNumbers.length <= 5) {
    return 1;
  } else if (chartChillingData?.dailyUtahNumbers.length <= 20) {
    return 2;
  } else if (chartChillingData?.dailyUtahNumbers.length <= 55) {
    return 11;
  } else {
    return 23;
  }
};

export const cultivarChartStepHelper = (cultivarReportQueryData) => {
  const screenWidth = window.innerWidth;

  if (screenWidth < 1023) {
    return 45;
  } else if (
    cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays
      .length <= 5
  ) {
    return 1;
  } else if (
    cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays
      .length <= 20
  ) {
    return 2;
  } else if (
    cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays
      .length <= 65
  ) {
    return 7;
  }

  // } else if (cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays.length <= 55) {
  //     return 7
  // } else if (cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays.length <= 55) {
  //     return 7
  // } else if (cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays.length <= 55) {
  //     return 7
  // } else if (cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays.length <= 55) {
  //     return 7
  // } else if (cultivarReportQueryData?.cultivarRecommendation?.dailyGrowingDegreeDays.length <= 55) {
  //     return 7
  // } else {
  return 23;
};

export const harvestChartStepHelper = (harvestReportQueryData) => {
  const screenWidth = window.innerWidth;

  if (screenWidth < 1023) {
    return 45;
  } else if (
    harvestReportQueryData?.harvestDateRecommendation?.dailyGrowingDegreeDays
      .length <= 5
  ) {
    return 1;
  } else if (
    harvestReportQueryData?.harvestDateRecommendation?.dailyGrowingDegreeDays
      .length <= 20
  ) {
    return 2;
  } else if (
    harvestReportQueryData?.harvestDateRecommendation?.dailyGrowingDegreeDays
      .length <= 55
  ) {
    return 11;
  } else {
    return 23;
  }
};

export const convertDecadesViolin = (dates) => {
  return dates?.map((date) => {
    const datesMapMonth = moment(date, 'jYYYY/jMM/jDD').locale('fa').format('jMMMM')
    const datesMapDay = parseInt(moment(date, 'jYYYY/jMM/jDD').format('jDD'))
  
    if(0 < datesMapDay && datesMapDay <= 10) {
      return `دهه اول ${datesMapMonth}`
    } else if (11 <= datesMapDay && datesMapDay <= 20) {
      return `دهه دوم ${datesMapMonth}`
    } else {
      return `دهه سوم ${datesMapMonth}`
    }
  })

};


export const convertDecadesViolinText = (data) => {
  const datesMapMonth = moment(data, 'jYYYY/jMM/jDD').locale('fa').format('jMMMM')
  const datesMapDay = parseInt(moment(data, 'jYYYY/jMM/jDD').format('jDD'))
  

  if(0 < datesMapDay && datesMapDay <= 10) {
    return `دهه اول ${datesMapMonth}`
  } else if (11 <= datesMapDay && datesMapDay <= 20) {
    return `دهه دوم ${datesMapMonth}`
  } else {
    return `دهه سوم ${datesMapMonth}`
  }
}


export const calculateAverage = (data) => {
  const total = data?.reduce((acc, value) => acc + value, 0)
  const avg = total / data?.length
  return avg
}
